import React, { useEffect, useState } from "react";
import { API_BASE } from "../../Utils/constant";

const Guidelines = () => {
  const [guidelinesData, setGuidelinesData] = useState(null); // Use `null` to indicate no data initially
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGuidelines = async () => {
      try {
        const response = await fetch(`${API_BASE}/community_guide_lines`);
        if (!response.ok) {
          throw new Error("Failed to fetch community guidelines");
        }

        const data = await response.json();


        setGuidelinesData(data.data || {});
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGuidelines();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>Error: {error}</p>;
  }

  return (
    <div>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Community Guidelines
        </h1>
        <div className="terms-content">
          {guidelinesData ? (
            <div className="terms-text">
              <h3 className="text-body-b1 mb-0">{guidelinesData.title}</h3>
              <p className="text-body-b3 mb-0">{guidelinesData.content}</p>
            </div>
          ) : (
            <p>No guidelines available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
